
import React, { PropsWithChildren, useContext, useEffect } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import './HeaderComponent.css';
import { SideMenuContext } from '../../providers/SideMenuProvider/SideMenuProvider';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { useWidthContext } from '../../providers/Width';
import { Header } from '../../importCL';

export interface IMainNavigationItem {
    linkTitle: string;
    link: string;
    linkParam: string;
    linkNewTab: boolean;
}

export type TCreateSideMenu = {
    title: any;
    link?: string;
    linkParams?: string;
    newTab?: boolean;
    next?: TCreateSideMenu | TCreateSideMenu[];
};

interface IHeaderComponentProps extends MappedComponentProperties {
    className?: string;
    headerType?: 'light' | 'dark' | 'transparent' | 'black-white' | 'dark-blue' | 'no-bank';
    customMessageColumnSize?: number;
    logoUrl?: string;
    altText?: string;
    showCtaButton?: boolean;
    showHamburgerButton?: boolean;
    ctaLabel?: string;
    ctaLink?: string;
    ctaNewTab?: boolean;
    ctaId?: string;
    ctaIcon?: 'lock' | 'chevron' | 'back';
    hideCtaBtnsDesktop?: boolean;
    navBarLinks?: IMainNavigationItem[];
    container?: TCreateSideMenu;
    homeLabel?: string;
    homeLink?: string;
    printAllowed?: boolean;
}

export const HeaderComponentEditConfig = {
    emptyLabel: 'HeaderComponent',
    isEmpty: (props: PropsWithChildren<IHeaderComponentProps>) => {
        return !props || !props.headerType;
    },
};

const HeaderComponent = (props: PropsWithChildren<IHeaderComponentProps>): JSX.Element => {
    const { hamburgerOpen, setHamburgerOpen, hamburgerSide, setHamburgerContainer } = useContext(SideMenuContext);
    const { homeLabel = 'Home' } = props;
    const { homeLink = '/' } = props;
    const { width } = useWidthContext();

    function getNavBarLinks(map: IMainNavigationItem[] | undefined) {
        const navBarLinks: { label: any; path: string; param: string; newTab: boolean; }[] = [];
        if (map !== undefined) {
            map.forEach(item => {
                const obj = {
                    label: transformHTMLParserLinks(item.linkTitle),
                    path: item.link,
                    param: item.linkParam,
                    newTab: item.linkNewTab,
                };
                navBarLinks.push(obj);
            });
        }
        return navBarLinks;
    }

    function getCTAParams() {
        if (props.ctaLabel !== undefined) {
            const obj = {
                label: props.ctaLabel,
                path: props.ctaLink,
                newTab: props.ctaNewTab,
                icon: props.ctaIcon,
            };
            return obj;
        }
        return;

    }

    useEffect(() => {
        if (!props.container)
            return;

        const obj = {
            'title': homeLabel,
            'link': homeLink,
            'next': props.container,
        };

        setHamburgerContainer(obj);
    }, [props.container]);

    useEffect(() => {
        const sideDrawer = document.querySelector('.SideMenu');
        if (sideDrawer) {
            sideDrawer.setAttribute('style', `min-height:${props.isInEditor ? '': '100%'}`);
        }
    }, [props.isInEditor]);

    return (
        <>
            <Header
                id='header-component'
                className={`Header ${props.className || ''}`}
                theme={props.headerType === 'dark-blue' ? 'dark' : props.headerType}
                customMessageColumnSize={props.customMessageColumnSize}
                navBarLinks={getNavBarLinks(props.navBarLinks)}
                hideNavButtonsOnDesktop={props.hideCtaBtnsDesktop}
                showCTAButton={props.showCtaButton}
                CTAParams={getCTAParams()}
                ctaId={props.ctaId}
                hamburger={props.showHamburgerButton}
                hamburgerSide={hamburgerSide}
                isHamburgerOpen={hamburgerOpen}
                hamburgerCallBack={() => setHamburgerOpen(!hamburgerOpen)}
                logoAlt={props.altText}
                logoURL={props.logoUrl}
                allowPrint={props.printAllowed}
                legacy={props.printAllowed}
            />  
        </>);
};

export default HeaderComponent;
